import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAfval = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M24.82 34H11.18a1.28 1.28 0 0 1-1.28-1.18L8 12h20l-1.9 20.82A1.28 1.28 0 0 1 24.82 34"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m23.38 14.563-.69 15.13-1-.046.69-15.13zM18.5 13.89V30.5h-1V13.89zM13.62 14.517l.69 15.13-1 .046-.69-15.13z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M10 8h16a2 2 0 0 1 2 2H8a2 2 0 0 1 2-2"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M16 6.5A1.5 1.5 0 0 0 14.5 8h-1A2.5 2.5 0 0 1 16 5.5h4A2.5 2.5 0 0 1 22.5 8h-1A1.5 1.5 0 0 0 20 6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M20 32.57c0-3.79 3.13-10.28 7-10.28s7 6.49 7 10.28S30.87 36 27 36s-7 .36-7-3.43"
    />
    <path
      fill="#85E3F9"
      d="M25.5 20h3a.45.45 0 0 1 .38.7L27 23.43l-1.88-2.73a.45.45 0 0 1 .38-.7"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAfval);

export default ForwardRef;
